/* eslint-disable no-else-return */
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedHTMLMessage } from 'react-intl'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import UplayIntegration from '../../components/UplayIntegration/UplayIntegration'
import SteamIntegration from '../../components/SteamIntegration/SteamIntegration'
import EpicIntegration from '../../components/EpicIntegration/EpicIntegration'
import RCIntegration from '../../components/RCIntegration/RCIntegration'
import MicrosoftIntegration from '../../components/MicrosoftIntegration/MicrosoftIntegration'
import ActivationKey from '../../components/ActivationKey/ActivationKey'
import ActivationKeyExpiration from '../../components/ActivationKey/ActivationKeyExpiration'
import ContentInstructionsModal from '../../components/Modal/ContentInstructionsModal/ContentInstructionsModal'

import './ContentItem.scss'

export default class ContentItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
  }

  _toggleModal = () => {
    const { modalOpen } = this.state
    this.setState({
      modalOpen: !modalOpen,
    })
  }

  handleRevealContentKey = partnerId => {
    const {
      handleReveal,
      contentItem: { contentId },
    } = this.props
    return handleReveal(contentId, partnerId)
  }

  renderContentKey() {
    const {
      contentItem: {
        contentId,
        activationKey,
        staticKey,
        name,
        provider,
        thirdPartyRedeemed,
        expiryDate,
        display,
      },
      couponCode,
    } = this.props

    if (staticKey) {
      if (!display) {
        return <FormattedMessage id="global.label.noKey" />
      }
      return (
        <ActivationKey
          activationKey={activationKey}
          staticKey={staticKey}
          expiryDate={expiryDate}
          handleReveal={this.handleRevealContentKey}
        />
      )
    } else if (activationKey && provider === 'RobotCache') {
      if (!display) {
        return <FormattedMessage id="global.label.noKey" />
      }
      return (
        <>
          <ActivationKeyExpiration expiryDate={expiryDate} />
          <RCIntegration
            redeemed={thirdPartyRedeemed}
            contentName={name}
            activationKey={activationKey}
            contentId={contentId}
            couponCode={couponCode}
          />
        </>
      )
    } else if (activationKey && provider === 'Epic') {
      if (!display) {
        return <FormattedMessage id="global.label.noKey" />
      }
      return (
        <>
          <ActivationKeyExpiration expiryDate={expiryDate} />
          <EpicIntegration
            redeemed={thirdPartyRedeemed}
            contentName={name}
            activationKey={activationKey}
            contentId={contentId}
            couponCode={couponCode}
          />
        </>
      )
    } else if (activationKey && provider === 'Ubisoft') {
      if (!display) {
        return <FormattedMessage id="global.label.noKey" />
      }
      return (
        <>
          <ActivationKeyExpiration expiryDate={expiryDate} />
          <UplayIntegration
            redeemed={thirdPartyRedeemed}
            contentName={name}
            activationKey={activationKey}
            contentId={contentId}
            couponCode={couponCode}
          />
        </>
      )
    } else if (activationKey && provider === 'Steam') {
      if (!display) {
        return <FormattedMessage id="global.label.noKey" />
      }
      return (
        <>
          <ActivationKeyExpiration expiryDate={expiryDate} />
          <SteamIntegration
            redeemed={thirdPartyRedeemed}
            contentName={name}
            activationKey={activationKey}
            contentId={contentId}
            couponCode={couponCode}
          />
        </>
      )
    } else if (activationKey && provider === 'Microsoft') {
      if (!display) {
        return <FormattedMessage id="global.label.noKey" />
      }
      return (
        <>
          <ActivationKeyExpiration expiryDate={expiryDate} />
          <MicrosoftIntegration
            redeemed={thirdPartyRedeemed}
            contentName={name}
            activationKey={activationKey}
            contentId={contentId}
            couponCode={couponCode}
            handleReveal={this.handleRevealContentKey}
          />
        </>
      )
    }
    if (!display) {
      return <FormattedMessage id="global.label.noKey" />
    }
    return (
      <ActivationKey
        activationKey={activationKey}
        staticKey={staticKey}
        expiryDate={expiryDate}
        handleReveal={this.handleRevealContentKey}
      />
    )
  }

  renderContentInstruction = () => {
    const {
      contentItem: { activationKey, staticKey, provider, name, display },
    } = this.props

    if (!display) {
      return (
        <p className="header">
          <FormattedMessage id="global.label.noKeyDescription" values={{ contentTitle: name }} />
        </p>
      )
    }

    if ((activationKey && staticKey) || (activationKey && !staticKey)) {
      return (
        <div>
          <p className="header">
            <FormattedMessage
              id={`contentProvider.${provider}.header.description`}
              values={{ contentTitle: name }}
            />
          </p>
          <p>
            <a
              onClick={this._toggleModal}
              tabIndex={0}
              role="button"
              aria-pressed="false"
              aria-label={`${name} instructions`}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') this._toggleModal()
              }}
              style={{ cursor: 'pointer' }}
            >
              <u>
                <FormattedMessage id="global.label.providerInstructionLink" />
              </u>
            </a>
          </p>
        </div>
      )
    } else if (!activationKey) {
      return (
        <p className="header">
          <FormattedMessage id="global.label.noKeyDescription" values={{ contentTitle: name }} />
        </p>
      )
    }
  }

  renderReleaseDate() {
    const {
      contentItem: { releaseDate },
    } = this.props

    return (
      <div>
        <p className="header mt-3">
          <FormattedMessage
            id="global.label.releaseDate"
            values={{
              date: releaseDate || 'TBD',
            }}
          />
        </p>
        <p className="header mt-3">
          <FormattedMessage id="global.general.releaseDateDisclaimer" />
        </p>
      </div>
    )
  }

  render = () => {
    const {
      contentItem: {
        name,
        imageUrl,
        provider,
        contentRatings,
        legalAttributeTitle,
        legalAttributeDescription,
        legalAttributeUrl,
      },
      extraProviders,
      creditsAvailable,
      isExpired,
    } = this.props
    const { modalOpen } = this.state

    return (
      <div className="mb-5 contentItem-page">
        <div className="row">
          <div className="col-12 col-md-auto d-flex justify-content-center">
            <div>
              <img
                src={imageUrl}
                className="summary-activation-content-image"
                alt={name}
                aria-label={name}
              />
            </div>
          </div>
          <div className="col">
            <h4 className="mt-3">
              {`${name} - `}
              <FormattedMessage id={`contentProvider.${provider}.content.name`} />
            </h4>
            {this.renderContentInstruction()}
            <ContentInstructionsModal
              isOpen={modalOpen}
              toggle={this._toggleModal}
              message={`contentProvider.${provider}.instruction.text`}
            />
            {this.renderContentKey()}
            {this.renderReleaseDate()}
            <div className="mt-3 d-flex flex-wrap">
              {contentRatings.map((ratings, index) => (
                <div key={ratings.rating.id} className="d-flex">
                  <img
                    key={ratings.rating.id}
                    src={ratings.rating.fileName}
                    alt={ratings.rating.name}
                    aria-label={ratings.rating.name}
                    className={`mb-3 img-fluid contentItem-page__ratingImg ${
                      index === 0 ? 'mr-1' : 'mx-1'
                    }`}
                  />
                </div>
              ))}
            </div>
            <div className="my-2 myFlag2">
              <p className="content-attribute m-0">{legalAttributeTitle}</p>
              <p className="content-attribute m-0">{legalAttributeDescription}</p>
              <p className="content-attribute m-0">
                <span dangerouslySetInnerHTML={{ __html: legalAttributeUrl }} />
              </p>
            </div>

            {creditsAvailable > 0 && isExpired ? (
              <div className="mb-3">
                <FormattedHTMLMessage id="error.coupon.couponExpiredCredits" />
              </div>
            ) : null}
            <div className="myFlag1">
              {extraProviders.map((providerItem, index) => (
                <div key={`my-reward-${index + 1}`} className="my-1">
                  <p className="content-attribute m-0">
                    <FormattedMessage id={`contentProvider.${providerItem}.legalAttribute.title`} />
                  </p>
                  <p className="content-attribute m-0">
                    <FormattedMessage
                      id={`contentProvider.${providerItem}.legalAttribute.description`}
                    />
                  </p>
                  <p className="content-attribute m-0">
                    <FormattedHTMLMessage
                      id={`contentProvider.${providerItem}.legalAttribute.url`}
                    />
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ContentItem.propTypes = {
  contentItem: PropTypes.object.isRequired,
}
